import moment from 'moment';

export enum EShakaPackagerPackagingMode {
  Full = 'full',
  MetadataOnly = 'metadata_only',
}

export const DEFAULT_SHAKA_PACKAGER_PACKAGING_MODE =
  EShakaPackagerPackagingMode.Full;

export interface ShakaPackagerEligibleMedia {
  mediaId: number;
  mediaName: string;
  sourcePath: string;
  transcodingJobUid: string;
  jobCount: number;
  earliestStartTime: moment.Moment;
  latestStartTime: moment.Moment;
  existingCount: number;
  existingStatus: string | null;
  existingFullMode: boolean | null;
  /** When the latest packager job for this media was created (null if never scheduled). */
  existingPackagerCreatedAt: moment.Moment | null;
  existingPackagerLastUpdateAt: moment.Moment | null;
}

export function isFullPackagingMode(mode: EShakaPackagerPackagingMode): boolean {
  return mode === EShakaPackagerPackagingMode.Full;
}

export function packagingModeLabel(mode: EShakaPackagerPackagingMode): string {
  return mode === EShakaPackagerPackagingMode.Full ? 'Full' : 'Metadata only';
}

export function existingModeLabel(fullMode: boolean | null): string {
  if (fullMode === null || fullMode === undefined) {
    return '';
  }
  return fullMode ? 'Full' : 'Metadata only';
}
